import { ReactComponent as PeopleIcon } from 'assets/icons/users/people.svg';
import { ReactComponent as Profile2UsersIcon } from 'assets/icons/users/profile-2users.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/users/profile.svg';
import { ReactComponent as UserIcon } from 'assets/icons/users/user.svg';
import { ReactComponent as UsersIcon } from 'assets/icons/users/users.svg';

export const users = {
  people: PeopleIcon,
  'profile-2-users': Profile2UsersIcon,
  profile: ProfileIcon,
  user: UserIcon,
  users: UsersIcon,
};
